<span
  class="date-spanner"
  [matTooltip]="'Browser time: {time}' | translate: { time: (date | formatDateTime) }"
  [matTooltipDisabled]="!isTimezoneDifference"
>
  {{ machineTime | formatDateTime }}
</span>